import yup from "yup";
import locale from "@bonliva-crm/locale";
import { WeekYear } from "@bonliva-crm/common";
import { GetTravelConfirmationByIdQuery } from "@graphql";

export interface TravelConfirmationFormData {
  files: File[];
  weeks: TravelWeek[];
  totalCost: string;
  totalExVAT?: boolean;
}

export interface TravelWeek {
  weekYear: WeekYear;
  isTravel: boolean;
  cost: string;
  description: string;
  startDate: Date;
  endDate: Date;
  note: string;
}

export const validationSchema = yup.object<TravelConfirmationFormData>({
  files: yup.array(),
  weeks: yup
    .array(
      yup.object<Partial<TravelWeek>>({
        description: yup
          .string()
          .nullable(true)
          .when("isTravel", {
            is: (v) => !!v,
            then: (s) => s.required(locale.fieldIsMandatory("Beskrivning av resa"))
          }),
        isTravel: yup.boolean(),
        startDate: yup
          .date()
          .nullable(true)
          .when("isTravel", {
            is: (v) => !!v,
            then: (s) =>
              s.test("startDate", locale.FromTravel, function testStartDate(s) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                const { endDate: e } = this.parent;
                return e || s;
              })
          }),
        endDate: yup
          .date()
          .nullable(true)
          .when("isTravel", {
            is: (v) => !!v,
            then: (s) =>
              s.test("endDate", locale.ToTravel, function testStartDate(e) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                const { startDate: s } = this.parent;
                return e || s;
              })
          })
      })
    )
    .min(1, locale.Period) as yup.Schema<any>,
  totalCost: yup.string().required(locale.fieldIsMandatory(locale.TotalCost))
});

export function mapDataToValues(
  data: GetTravelConfirmationByIdQuery
): TravelConfirmationFormData {
  return {
    files: [],
    totalCost: data.travelConfirmationById.totalCost.toString(),
    totalExVAT: data.travelConfirmationById.totalExVAT ?? false,
    weeks: data.travelConfirmationById.allWeeks.map((x) => ({
      weekYear: x.weekYear,
      cost: x.cost.toString(),
      description: x.description,
      startDate: x.startDate,
      endDate: x.endDate,
      isTravel: x.isTravel,
      note: x.note
    }))
  };
}
